import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useWishlist } from '../context/WishlistContext';
import { useLanguage } from '../context/LanguageContext';

const WishlistIcon = () => {
  const navigate = useNavigate();
  const { getWishlistCount } = useWishlist();
  const { t } = useLanguage();
  
  const count = getWishlistCount();

  const handleClick = () => {
    navigate('/wishlist');
  };

  return (
    <button
      onClick={handleClick}
      className="relative p-2 text-gray-600 dark:text-stone-300 hover:text-red-500 transition-colors duration-200"
      title={t('wishlist')}
    >
      <i className="fas fa-heart text-xl"></i>
      {count > 0 && (
        <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center font-semibold">
          {count > 99 ? '99+' : String(count)}
        </span>
      )}
    </button>
  );
};

export default WishlistIcon;
